import { Col, Row, Select } from 'antd';
import React, { useState } from 'react';

import Form from '@/src/shared/components/Form';
import Heading from '@/src/shared/components/Heading';
import X from '@/src/shared/components/Icon/_icons/X';
import Sanitize from '@/src/shared/components/Sanitize';
import { space } from '@/styles';
import { rowProps } from '@/utils/rowColHelpers';
import { multiSelectProps } from '@/utils/selectHelpers';

import style from '../style';
import PublicationsModal from './PublicationsModal';

const { Option } = Select;
const { m } = space;
const index = props => {
  const { form, publications, profile, designData, setManuallyTouched } = props;
  const { block, blockComponents } = designData;

  const [isVisible, setVisibility] = useState(false);
  const clear = () => {
    form.setFieldsValue({
      GeneralPublications: [],
    });

    setManuallyTouched(true)
  };

  return (
    <>
      <PublicationsModal
        visible={isVisible}
        closeModal={() => {
          setVisibility(false);
        }}
      />
      <div css={style.rowWidth}>
        <Heading type={3} theme="primaryGray" size="md" weight="bold">
          {block.BlockTitle}
        </Heading>
        {blockComponents.map(c => (
          <div key={c.BlockComponentId} css={style.description}>
            <Sanitize>{c.Paragraph}</Sanitize>
          </div>
        ))}
        <Row {...rowProps} css={m.t16}>
          <Col xs={24}>
            <Form.Item
              css={style.hasClear}
              label={
                <>
                  <span>General Publications</span>
                  <Heading
                    type={4}
                    weight="bolder"
                    size="xs"
                    css={style.publicationClear}
                    onClick={clear}
                  >
                    <X /> <span css={m.l8}>Clear Choices</span>
                  </Heading>
                </>
              }
            >
              {form.getFieldDecorator('GeneralPublications', {
                initialValue: profile.GeneralPublications,
              })(
                <Select
                  {...multiSelectProps(false)}
                  maxTagCount={5}
                  size="large"
                  css={style.whiteField}
                >
                  {publications.map(p => (
                    <Option key={`${p.PublicationCode}-pub`} value={p.PublicationCode}>
                      {p.PublicationDescription}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>
      </div>
    </>
  );
};

index.propTypes = {};

export default index;
